import {EventTemplateCategoryType} from "../../../../shared/enums/eventTemplateCategoryType";
import EventTemplateSummaryItem from "./eventTemplateSummaryItem";

/**
 * Represents an event template category in the event catalogue.
 */
export default class EventTemplateCategory {
  id: string;
  name: string;
  /**
   * The number of event templates belong to this event template category.
   */
  eventTemplatesCount: number;
  /**
   * A list of event templates belong to this event template category.
   */
  eventTemplates: EventTemplateSummaryItem[];
  categoryType: EventTemplateCategoryType;

  constructor(
    id: string,
    name: string,
    eventTemplatesCount: number,
    eventTemplates: EventTemplateSummaryItem[],
    categoryType: EventTemplateCategoryType
  ) {
    this.id = id;
    this.name = name;
    this.eventTemplatesCount = eventTemplatesCount;
    this.eventTemplates = eventTemplates;
    this.categoryType = categoryType;
  }
}
